import script from "./AdvertiserByPublishers.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertiserByPublishers.vue?vue&type=script&setup=true&lang=js"

import "./AdvertiserByPublishers.vue?vue&type=style&index=0&id=5b8d8d3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b8d8d3a"]])

export default __exports__